import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Container,
  useTheme,
  useMediaQuery,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Stack,
  alpha,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import WbSunnyIcon from "@mui/icons-material/WbSunny"; // Ícone relacionado a energia/positividade
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

export const Navbar: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [drawerOpen, setDrawerOpen] = React.useState(false);

  const navItems = ["Diferenciais", "Planos", "Como Funciona", "Contato"];

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  const logo = (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <WbSunnyIcon sx={{ color: theme.palette.primary.main, fontSize: 32 }} />
      <Typography
        variant="h5"
        sx={{ fontWeight: 700, color: theme.palette.text.primary }}
      >
        Sol Plano
      </Typography>
    </Box>
  );

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        backgroundColor: alpha(theme.palette.background.paper, 0.9),
        backdropFilter: "blur(5px)",
        borderBottom: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Container maxWidth="xl">
        <Toolbar
          disableGutters
          sx={{
            justifyContent: "space-between",
            height: 72,
            px: { xs: 1, sm: 2 },
          }}
        >
          {logo}

          {!isMobile && (
            <Stack direction="row" spacing={1} sx={{ mx: 2 }}>
              {navItems.map((item) => (
                <Button
                  key={item}
                  sx={{
                    color: theme.palette.text.secondary,
                    fontWeight: 600,
                    px: 2,
                    borderRadius: 1,
                    "&:hover": {
                      color: theme.palette.primary.dark,
                      backgroundColor: alpha(theme.palette.primary.main, 0.1),
                    },
                  }}
                  href={`#${item.toLowerCase().replace(" ", "-")}`}
                >
                  {item}
                </Button>
              ))}
            </Stack>
          )}

          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Button
              variant="contained"
              color="secondary"
              href="#formulario"
              endIcon={<ArrowForwardIcon />}
              sx={{
                display: { xs: "none", md: "flex" },
              }}
            >
              Simular Agora
            </Button>

            {isMobile && (
              <IconButton
                color="primary"
                aria-label="open drawer"
                edge="end"
                onClick={handleDrawerToggle}
                sx={{ ml: 1 }}
              >
                <MenuIcon sx={{ fontSize: 30 }} />
              </IconButton>
            )}
          </Box>
        </Toolbar>
      </Container>

      {/* Menu Mobile */}
      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={handleDrawerToggle}
        PaperProps={{
          sx: {
            width: "85%",
            maxWidth: "350px",
            p: 2,
            backgroundColor: theme.palette.background.default,
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 3,
          }}
        >
          {logo}
          <IconButton
            onClick={handleDrawerToggle}
            sx={{ color: theme.palette.text.secondary }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <List sx={{ mb: 3 }}>
          {navItems.map((item, index) => (
            <ListItem disablePadding key={item} sx={{ mb: 1 }}>
              <ListItemButton
                onClick={handleDrawerToggle}
                component="a"
                href={`#${item.toLowerCase().replace(" ", "-")}`}
                sx={{ borderRadius: 1, py: 1.5 }}
              >
                <ListItemIcon sx={{ minWidth: 40 }}>
                  <ArrowForwardIcon
                    fontSize="small"
                    sx={{ color: theme.palette.secondary.main }}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={item}
                  primaryTypographyProps={{
                    fontWeight: 600,
                    color: theme.palette.text.primary,
                  }}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>

        <Button
          variant="contained"
          color="secondary"
          fullWidth
          href="#formulario"
          endIcon={<ArrowForwardIcon />}
          sx={{ py: 1.5 }}
        >
          Simular Agora
        </Button>
      </Drawer>
    </AppBar>
  );
};
